import React, { useMemo } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'

import MuiFab from '@material-ui/core/Fab'
import MuiIconButton from '@material-ui/core/IconButton'

import CircularLoader from '@galo-monitor/web-components/Loader/CircularLoader'
import Tooltip from '@galo-monitor/web-components/Tooltip'

import useStyles from './styles'

const IconButton = (props) => {
  const {
    withOpacity,
    children,
    className,
    tooltip,
    marginVertical,
    marginHorizontal,
    shadow,
    loading,
    styleVariant,
    placement,
    onClick,
    fab,
    ...otherProps
  } = props

  const classes = useStyles()

  const classesNames = []

  if (shadow) {
    classesNames.push(classes.btnShadow)
  }
  if (withOpacity) {
    classesNames.push(classes.withOpacity)
  }
  if (!isEmpty(classes[styleVariant])) {
    classesNames.push(classes[styleVariant])
  }
  if (className) {
    classesNames.push(className)
  }

  const MuiButton = useMemo(
    () => {
      if (fab) {
        return MuiFab
      }
      return MuiIconButton
    },
    [fab]
  )

  let button = (
    <MuiButton
      { ...otherProps }
      className={ classesNames.join(' ') }
      onClick={ loading ? () => {} : onClick }
    >
      {loading ? <CircularLoader color="inherit" size={ 22 } /> : children}
    </MuiButton>
  )

  if (!isEmpty(tooltip)) {
    button = (
      <Tooltip title={ tooltip } placement={ placement }>
        {button}
      </Tooltip>
    )
  }
  if (marginVertical || marginHorizontal) {
    button = (
      <div
        className={ [
          marginHorizontal ? classes.iconButtonMarginHorizontal : null,
          marginVertical ? classes.iconButtonMarginVertical : null
        ].join(' ') }
      >
        {button}
      </div>
    )
  }

  return button
}

IconButton.propTypes = {
  withOpacity: PropTypes.bool,
  children: PropTypes.any,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  marginVertical: PropTypes.bool,
  marginHorizontal: PropTypes.bool,
  fab: PropTypes.bool,
  shadow: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  loading: PropTypes.bool,
  styleVariant: PropTypes.string,
  placement: PropTypes.string,
  /** Used to control the button's purpose,
   This property passes the value to the type attribute of the native button component. */
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
}

IconButton.defaultProps = {
  withOpacity: false,
  children: '',
  onClick: () => {},
  tooltip: null,
  className: null,
  marginVertical: false,
  marginHorizontal: true,
  shadow: false,
  size: 'medium',
  loading: false,
  fab: false,
  styleVariant: null,
  placement: 'bottom',
  type: 'button'
}

export default IconButton
